// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2YfOi","inner":"Footer_inner__u-FAr","nextIcon":"Footer_nextIcon__1H9BL","innerLeft":"Footer_innerLeft__3zf93"};